import { Link } from 'react-router-dom';
import './NotFound.css';

function NotFound() {
  return (
    <div className="not-found">
      <div className="not-found-content">
        <div className="not-found-code">404</div>
        <h1 className="not-found-title">页面不存在</h1>
        <p className="not-found-desc">
          您访问的页面不存在，请检查网址是否正确。
        </p>
        <Link to="/" className="btn-primary">
          返回首页
        </Link>
      </div>
    </div>
  );
}

export default NotFound;
